<template>
    <div v-bind:data-building-id="buildingProcessedId" class="card buildingCard buildingCard-listContainer">
        <div class="card-body buildingCard-body">
            <h5 class="card-title buildingCard-title">
                 <span class="iconBeforeTitle">
                    <i class="far fa-calendar-alt"></i>
                 </span>
                Test Schedule
                <ToolTip>
                    <sup class="superScript">
                        <i class="fas fa-info-circle"
                           data-toggle="tooltip"
                           data-placement="top"
                           data-html="true"
                           title=""
                           data-original-title='Manage the scheduled test'
                        ></i>
                    </sup>
                </ToolTip>

                <RequiresSitePermissions class="float-right" v-bind:required-permissions="['WRITE']" v-bind:site-id="buildingProcessedId">
                    <template v-if="!comingScheduleTest.meta['can_full_building_test'] || quickTestButtonDisabled">
                        <ToolTip>
                            <span class="btn btn-sm buildingCard-body-btn disabled"
                                  v-bind:class="[scheduledTests.length ? 'schedule-outline' : 'schedule-filled']"
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  data-html="true"
                                  title=""
                                  v-bind:data-original-title="!comingScheduleTest.meta['can_full_building_test'] ? 'There is a testing under going, full building quick test is disabled.' : 'Full building quick test is only available every 5 minutes.'">
                                Run Quick Test Now
                            </span>
                        </ToolTip>
                    </template>
                    <button v-else type="button" class="btn btn-sm buildingCard-body-btn"
                            v-bind:class="[scheduledTests.length ? 'schedule-outline' : 'schedule-filled']"
                            @click="resetQuickTestModal();quickTest.showModal=true">
                        Run Quick Test Now
                    </button>

                </RequiresSitePermissions>
            </h5>
            <template v-if="scheduledTests.length || editingModeAdd">
                <table class="table buildingCard-table buildingCard-table-info ">
                    <thead>
                    <tr v-if="scheduledTests.length">
                        <th>UPCOMING EVENT</th>
                        <th>DEADLINE</th>
                        <th>TEST START</th>
                        <th></th>
                    </tr>
                    <tr v-else>
                        <th colspan="4" class="p-1"></th>
                    </tr>
                    </thead>
                    <tbody>

                    <tr v-if="editingModeAdd">
                        <td colspan="4" v-bind:class="{inEditCanAdd: editingModeAdd}">
                            <ExecutionDateFormCard
                                    :key="0"
                                    @reFetchTests="$emit('reFetchScheduledTests');"
                                    @cancel = "setModifyMode()"
                                    v-bind:building_id="buildingId"
                                    v-bind:building_test_id="undefined"
                                    v-bind:scheduleTest="undefined"
                                    v-bind:comingScheduleTest="scheduledTests"
                                    v-bind:index="undefined"
                                    v-bind:report_type="undefined"
                                    v-bind:dead_line="undefined"
                                    v-bind:execution_date = "undefined"></ExecutionDateFormCard>
                        </td>
                    </tr>

                    <template v-for="(scheduleTest,index) in scheduledTests">
                        <tr v-bind:class="{inEdit: currentEdit === scheduleTest.id}" key:scheduleTest.id>
                            <!--Rerun is true -->
                            <template v-if="scheduleTest.status === 'failed'">
                                <td>
                                    <template v-if="scheduleTest.report_type === 'annual'">
                                        Annual Maintenance <span class="d-none d-sm-inline">Test</span>
                                    </template>
                                    <template v-else-if="scheduleTest.report_type === 'six-months'">
                                        Six-Months Maintenance <span class="d-none d-sm-inline">Test</span>
                                    </template>
                                </td>
                                <td class="d-ss-none">{{tools.formatDate(new Date(scheduleTest.dead_line * 1000))}}</td>
                                <td v-if="scheduleTest.can_rerun === true">
                                    TBD
                                </td>
                                <td v-else>{{tools.formatDateTime(new Date(scheduleTest.child.execution_date * 1000))}}</td>
                                <td class="buildingCard-table-infoContainer">
                                    <template v-if="scheduleTest.can_rerun === true">
                                        <RequiresSitePermissions class="float-left" v-bind:required-permissions="['WRITE']" v-bind:site-id="buildingId">
                                            <ToolTip>
                                                <span class="toolTip"
                                                      data-toggle="tooltip"
                                                      data-placement="top"
                                                      data-html="true"
                                                      title=""
                                                      data-original-title='Rerun the test on failed devices. Rerun it only after maintenance'>
                                                    <a href="javascript:void(0)" v-on:click="confirmPopup(buildingId, scheduleTest.id)">
                                                        <i class="fas fa-sync-alt buildingCard-table-info buildingCard-table-infoPlay"></i>
                                                    </a>
                                                    <template slot="fallback">
                                                        <i class="fas fa-clock buildingCard-table-info buildingCard-table-infoClock"></i>
                                                    </template>
                                                </span>
                                            </ToolTip>
                                        </RequiresSitePermissions>
                                        <RequiresSitePermissions class="float-right" v-bind:required-permissions="['WRITE']" v-bind:site-id="buildingId">
                                            <ToolTip>
                                                <span class="toolTip"
                                                      data-toggle="tooltip"
                                                      data-placement="top"
                                                      data-html="true"
                                                      title=""
                                                      data-original-title='Cancel this scheduled test.'>
                                                    <a href="javascript:void(0)" v-on:click="confirmCancelTest(buildingId, scheduleTest.id)">
                                                       <i class="fas fa-trash-alt buildingCard-table-info buildingCard-table-infoCancelRerun"></i>
                                                    </a>
                                                </span>
                                            </ToolTip>
                                        </RequiresSitePermissions>
                                    </template>

                                    <template v-else-if="scheduleTest.child.status === 'locked'">
                                        <i class="fas fa-lock buildingCard-table-info buildingCard-table-infoLocked"></i>
                                    </template>

                                    <template v-else-if="scheduleTest.child.status === 'started'">
                                        <i class="fas fa-hourglass-start buildingCard-table-info buildingCard-table-infoStarted"></i>
                                    </template>
                                </td>
                            </template>
                            <template v-else-if="['booked', 'locked', 'started'].indexOf(scheduleTest.status) > -1">
                                <td>
                                    <template v-if="scheduleTest.report_type === 'supplementary'">
                                        Supplementary Scheduled <span class="d-none d-sm-inline">Test </span>
                                    </template>
                                    <template v-else-if="scheduleTest.report_type === 'annual'">
                                        Annual Scheduled <span class="d-none d-sm-inline">Test</span>
                                    </template>
                                    <template v-else-if="scheduleTest.report_type === 'six-months'">
                                        Six-Months Scheduled <span class="d-none d-sm-inline">Test</span>
                                    </template>
                                    <template v-else-if="!scheduleTest.test_all">
                                        Partial Maintenance <span class="d-none d-sm-inline">Test</span>
                                    </template>
                                    <template v-else>
                                        <span class="d-none d-sm-inline">Scheduled</span> Maintenance
                                    </template>
                                </td>
                                <td class="d-ss-none" v-if="scheduleTest.dead_line">{{tools.formatDate(new
                                    Date(scheduleTest.dead_line * 1000))}}
                                </td>
                                <td v-else></td>
                                <td>  {{tools.formatDateTime(new Date(scheduleTest.execution_date * 1000))}}</td>
                                <td class="buildingCard-table-infoContainer">
                                    <template v-if="scheduleTest.can_update === true">
                                        <RequiresSitePermissions v-bind:required-permissions="['WRITE']" v-bind:site-id="buildingId">
                                            <a href="javascript:void(0)"
                                               @click="setModifyMode(false, scheduleTest.id)">
                                                <i class="fas fa-pen buildingCard-table-info buildingCard-table-infoEdit"></i>
                                            </a>
                                            <template slot="fallback">
                                                <i class="disabled fas fa-pen buildingCard-table-info buildingCard-table-infoEdit"></i>
                                            </template>
                                        </RequiresSitePermissions>
                                    </template>

                                    <template v-else-if="scheduleTest.status === 'locked'">
                                        <i class="fas fa-lock buildingCard-table-info buildingCard-table-infoLocked"></i>
                                    </template>

                                    <template v-else-if="scheduleTest.status === 'started'">
                                        <i class="fas fa-hourglass-start buildingCard-table-info buildingCard-table-infoStarted"></i>
                                    </template>
                                </td>
                            </template>
                            <template v-if="msgValidation.message !== undefined && msgValidation.id === scheduleTest.id">
                                <td class="alert alert-danger buildingCard-table-msg" role="alert" colspan="5">{{msgValidation.message}}</td>
                            </template>
                        </tr>
                        <tr v-if="currentEdit === scheduleTest.id">
                            <td colspan="4">
                                <ExecutionDateFormCard
                                        :key="scheduleTest.id"
                                        @reFetchTests="$emit('reFetchScheduledTests'); "
                                        @cancel="setModifyMode()"
                                        v-bind:building_id="buildingId"
                                        v-bind:building_test_id.sync="scheduleTest.id"
                                        v-bind:scheduleTest="scheduleTest"
                                        v-bind:comingScheduleTest="scheduledTests"
                                        v-bind:index="index"
                                        v-bind:report_type="scheduleTest.report_type"
                                        v-bind:dead_line="scheduleTest.dead_line"
                                        v-bind:execution_date="scheduleTest.execution_date">
                                </ExecutionDateFormCard>
                            </td>
                        </tr>
                    </template>
                    </tbody>
                </table>
            </template>
            <div v-else class="emptyContent">
                <div class="emptyContent-default">
                    <h2 class="emptyContent-default-title text-light"><i class="far fa-calendar-alt"></i></h2>
                    <p class="emptyContent-default-desc text-light">Set your AFSS deadline and test start time</p>
                </div>
            </div>
            <ModalComponent
                    v-if="quickTest.showModal"
                    @execute="submitQuickTest(quickTest.buildingId)"
                    @close="quickTest.showModal = false;resetQuickTestModal();"
                    :headerClassName="'modalDefault'"
                    :executeBtnDisabled="quickTest.executeBtnDisabled"
                    :executeBtnClassName="quickTest.executeBtnClassName"
                    :executeBtnText="quickTest.executeBtnText"
                    :closeBtnText="quickTest.closeBtnText"
                    :executing="quickTest.submitting"
                    :confirm="quickTest"
            >
                <template v-slot:msg>
                    <p>This will start a quick test for all devices in the building immediately. A quick test lasts for 5 minutes and will check that:</p>
                    <ul>
                        <li><p>the emergency light is powered on and responding to commands</p></li>
                        <li><p>the lamp(s) are functioning correctly</p></li>
                        <li><p>the battery is connected and at the correct voltage</p></li>
                    </ul>
                    <p>A quick test will not verify that the battery lasts the full duration of 90 minutes and is not intended to replace a full discharge test.</p>
                </template>
            </ModalComponent>
            <ModalComponent
                    v-if="dataToPassToModal.showModal"
                    @execute="rerun(dataToPassToModal.buildingId,dataToPassToModal.id),dataToPassToModal.showModal = false"
                    @close="dataToPassToModal.showModal = false"
                    :confirm="confirm"
            ></ModalComponent>
            <DeleteModalComponent v-if="dataToPassToCancelModal.showModal"
                                  @close="resetCancelTest()"
                                  @delete="cancelTest(dataToPassToCancelModal.buildingId, dataToPassToCancelModal.buildingTestId).then(() => resetCancelTest())"
                                  :confirm="testCancelConfirm"></DeleteModalComponent>
        </div>
    </div>
</template>
<style>
</style>
<script>
import Tools from '@/app-model/tools.js';
import RequiresSitePermissions from "@/components/RequiresSitePermissions";
import ExecutionDateFormCard from '@/components/building-management/ExecutionDateFormCard.vue';
import ModalComponent from '@/components/modal/ModalComponent.vue';
import DeleteModalComponent from '@/components/modal/DeleteModalComponent.vue';
import ToolTip from '@/components/tool-tip/ToolTip.vue';

const tools = new Tools();
  export default {
    props: {
      buildingId: Number,
      scheduleTest: Object,
      comingScheduleTest: Object,
      buildingTimeZone: String,
    },
    components: {
      RequiresSitePermissions,
      ExecutionDateFormCard,
      ModalComponent,
      DeleteModalComponent,
      ToolTip
    },
    data () {
      return {
        currentEdit: 0,
        editingModeAdd: false,
        updatedObject:[],
        dataToPassToModal: {
          id: '',
          index: '',
          showModal: false,
        },
        quickTest: {
          buildingId: '',
          showModal: false,
          submitting: false,
          executeBtnDisabled: false,
          executeBtnClassName:'btn-primary',
          executeBtnText:'Run Quick Test',
          closeBtnText: 'Cancel',
          title: 'Run quick test?',
          msg: undefined,
          timer: undefined,
          buttonDisabled: false,
          buttonDisabledTimer: undefined,
        },
        dataToPassToCancelModal: {
          buildingId: '',
          buildingTestId: '',
          showModal: false,
        },
        confirm : {
          action: '',
          title: '',
          msg: '',
        },
        testCancelConfirm: {
          title: '',
          msg: ''
        },
        msgValidation: {
          id: undefined,
          message: undefined,
        },
        data: [],
      }
    },
    computed: {
      quickTestButtonDisabled: function () {
        if (!this.comingScheduleTest.meta['can_quick_test']) {
          clearTimeout(this.quickTest.buttonDisabledTimer);
          this.checkButtonDisabled(this.comingScheduleTest.meta['quick_expires_at']  * 1000);
        }
        return this.quickTest.buttonDisabled;
      },
      buildingProcessedId: function () {
        this.resetData();
        return this.buildingId;
      },
      tools: function () {
        return new Tools;
      },
      meta: function () {
        let {
          meta: {
            can_add = undefined
          } = {}
        } = this.comingScheduleTest;

        return {
          can_add
        };
      },
      scheduledTests: function () {
        this.data.splice(0, this.data.length);
        let {data = []} = this.comingScheduleTest;
        data = data.slice().reverse();
        for (let i = 0; i < data.length; i++) {
          data[i]['can_rerun'] = false;
          data[i]['can_update'] = data[i].status === 'booked';
          data[i]['child'] = {};
          data[i]['message'] = '';
          if (data[i].building_tests_id === 0){
            if (data[i].status === 'failed' && ['annual', 'six-months'].indexOf(data[i].report_type) > -1) {
              let child = data.find(el => el.building_tests_id === data[i].id);
              data[i]['can_rerun'] = child === undefined;
              data[i]['child'] = child === undefined? {} : child;
            }
            this.data.push(data[i]);
          }
        }

        return this.data;
      },
    },
    methods: {
      checkButtonDisabled(expiresAt) {
        let ts = new Date().getTime(), top = this;
        if (ts < expiresAt) {
          top.quickTest.buttonDisabledTimer = setTimeout(function () {
            top.quickTest.buttonDisabled = true;
            top.checkButtonDisabled(expiresAt)
          }, 1000)
        }
        else {
          top.quickTest.buttonDisabled = false;
          clearTimeout(this.quickTest.buttonDisabledTimer);
        }
      },
      setModifyMode(isAdd = false, testId = 0) {
        if(isAdd) {
          this.currentEdit = 0;
          this.editingModeAdd = true;
        }
        else {
          this.currentEdit = testId;
          this.editingModeAdd = false;
        }
      },
      confirmPopup: function ( buildingId, testId) {
        this.confirm = {
          action: '',
          title: 'Are you sure to Rerun this Test ?',
          msg:  '',
        };
        this.dataToPassToModal.showModal = true;
        this.dataToPassToModal.id = testId;
        this.dataToPassToModal.buildingId = buildingId;
      },

      resetData () {
        this.editingMode = false;
      },

      resetQuickTestModal () {
        this.quickTest.buildingId = this.buildingId;
        this.quickTest.showModal = false;
        this.quickTest.executeBtnDisabled = false;
        this.quickTest.submitting = false;
        this.quickTest.executeBtnClassName = 'btn-primary';
        this.quickTest.executeBtnText = 'Run Quick Test';
        this.quickTest.title = 'Run quick test?';
        this.quickTest.closeBtnText = 'Cancel';
        this.quickTest.msg = undefined;
        clearTimeout(this.quickTest.timer);
      },

      submitQuickTest (buildingId) {
        this.quickTest.executeBtnDisabled = true;
        this.quickTest.submitting = true;
        this.quickTest.executeBtnClassName = 'btn-secondary';
        this.quickTest.executeBtnText = 'Submitting ...';

        let top = this;

        let refreshLoad = (seconds, msg) => {
          if (seconds > 0) {
            this.quickTest.msg = msg + ' The popup window would be closed automatically in ' + seconds + ' seconds.';
            this.quickTest.timer = setTimeout(function () {
              seconds--;
              refreshLoad(seconds, msg)
            }, 1000)
          }
          else {
            this.resetQuickTestModal();
          }
        };


        this.$store.dispatch(
          'apiResult',
          {
            method: 'POST',
            path: `api/user-buildings/${buildingId}/devices-commands`,
            path_template: `/api/user-buildings/{building_id}/devices-commands`,
            building_id: buildingId,
            data: {type: 'quick'}
          }
        ).then(response => {
          this.quickTest.submitting = false;
          this.quickTest.closeBtnText = 'Close';
          switch (response.status) {
            case 200:
              this.quickTest.executeBtnText = 'Submitted';
              this.quickTest.title = 'Quick test submitted!';
              refreshLoad(10, 'Setup Quick test successfully, the test would be start very soon.');
              break;
            default:
              this.quickTest.msg = response.data.message;
              this.quickTest.executeBtnClassName = 'd-none';
              if (response.data['can_quick_test']) {
                clearTimeout(this.quickTest.buttonDisabledTimer);
                this.checkButtonDisabled(response.data['quick_expires_at']  * 1000);
              }

              break;
          }
        })
      },

      rerun (buildingId, buildingTestId) {
        this.msgValidation.message = undefined;
        this.msgValidation.id = undefined;
        this.$store.dispatch(
          'apiResult',
          {
            method: 'POST',
            path: `api/user-buildings/${buildingId}/schedule-test/${buildingTestId}/rerun`,
            path_template: `/api/user-buildings/{building_id}/schedule-test/{building_test_id}/rerun`,
            building_id: buildingId,
          }
        ).then(response => {
          switch (response.status) {
            case 200:
              this.$emit('reFetchScheduledTests')
              break
            case 422:
              this.msgValidation.id = buildingTestId;
              this.msgValidation.message = response.data.message;
              break
          }
        })
      },
      confirmCancelTest (buildingId, buildingTestId) {
        this.testCancelConfirm = {
          title: 'Are you sure you want to cancel the test?',
          msg: 'This will permanently remove the scheduled test. Existing test reports will continue to be available.',
        };
        this.dataToPassToCancelModal.buildingId = buildingId;
        this.dataToPassToCancelModal.buildingTestId = buildingTestId;
        this.dataToPassToCancelModal.showModal = true;
      },
      resetCancelTest () {
        this.dataToPassToCancelModal.buildingId = '';
        this.dataToPassToCancelModal.buildingTestId = '';
        this.dataToPassToCancelModal.showModal = false;
      },
      cancelTest (buildingId, buildingTestId) {
        return this.$store.dispatch(
          'apiResult',
          {
            method: 'DELETE',
            path: `api/user-buildings/${buildingId}/schedule-test/${buildingTestId}/rerun`,
            path_template: `/api/user-buildings/{building_id}/schedule-test/{building_test_id}/rerun`,
            building_id: buildingId,
          }
        ).then(response => {
          switch (response.status) {
            case 200:
              this.$emit('reFetchScheduledTests')
              break;
            case 422:
              this.msgValidation.id = buildingTestId;
              this.msgValidation.message = response.data.message;
              break;
          }
        });
      },
    }
  }
</script>

<style lang="scss" scoped>
    @import "@/../sass/_home_dashboard.scss";
    @import "@/../sass/_building_card.scss";
</style>